import { useState } from '@max/max';
import { RequestStatus, requestDataCenter } from '../utils/request';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
export function useRequest() {
    const [response, setResponse] = useState(null);
    const ctx = useMonitorEngineContext();
    const [requestStatus, setRequestStatus] = useState(RequestStatus.LOADING);
    const request = async (options) => {
        const { onSuccess, onError, onFinally, requestConfig } = options;
        try {
            setRequestStatus(RequestStatus.LOADING);
            const response = await requestDataCenter(requestConfig);
            // 保存响应数据
            setResponse(response);
            setRequestStatus(RequestStatus.SUCCESS);
            ctx._raptorReport?.monitorReportNetworkSuccess?.({
                apiPath: requestConfig.path
            });
            onSuccess?.(response);
        }
        catch (err) {
            ctx._raptorReport?.monitorReportNetworkFailed?.({
                apiPath: requestConfig.path
            });
            const error = err;
            setRequestStatus(RequestStatus.ERROR);
            onError?.(error);
        }
        finally {
            onFinally?.();
        }
    };
    return {
        response,
        requestStatus,
        request,
        setResponse,
        isLoading: requestStatus === RequestStatus.LOADING,
        isSuccess: requestStatus === RequestStatus.SUCCESS,
        isError: requestStatus === RequestStatus.ERROR
    };
}
